module.exports = __webpack_public_path__ + "static/media/Guinea.b0e701bc.png";